<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.add_notification") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: service_providers Type Input -->
          <base-select-input
            v-if="data.providers && data.receiverType.value === 'provider'"
            col="6"
            :optionsList="data.providers"
            :placeholder="$t('PLACEHOLDERS.service_providers_plural')"
            v-model="data.provider"
            required
            multiple
          />
          <!-- End:: Drivers Type Input -->

          <div class="col-12">
            <div class="row">
              <!-- Start:: Title Ar Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                required
              />
              <!-- End:: Title Ar Input -->

              <!-- Start:: Title En Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                required
              />
              <!-- End:: Title En Input -->

              <!-- Start:: Content Ar Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                required
              />
              <!-- End:: Content Ar Input -->

              <!-- Start:: Content En Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                required
              />
              <!-- End:: Content En Input -->
            </div>
          </div>
          <!-- Start:: Receiver Type Input -->
          <base-select-input
            col="6"
            :optionsList="receiverTypes"
            :placeholder="$t('PLACEHOLDERS.receiverType')"
            v-model="data.receiverType"
            required
          />
          <!-- End:: Receiver Type Input -->

          <!-- Start:: Clients Type Input -->
          <base-select-input
            v-if="data.clients && data.receiverType.value === 'client'"
            col="6"
            :optionsList="data.clients"
            :placeholder="$t('PLACEHOLDERS.clients_menu')"
            v-model="data.client"
            :loading="clientsPagination.isLoading"
            :enableInfiniteScroll="true"
            @reachEnd="handleClientsReachEnd"
            @search-change="handleClientsSearch"
            required
            multiple
          />

          <!-- Start:: Festival Providers Type Input -->
          <base-select-input
            v-if="data.receiverType.value === 'festival_provider'"
            col="6"
            :optionsList="festivalProviders"
            :placeholder="$t('MESSAGES.Festival providers')"
            v-model="data.festivalProvider"
            :loading="isFestivalProvidersLoading"
            required
            multiple
          />
          <!-- End:: Festival Providers Type Input -->

          <MapRegionSelector
            ref="map_point"
            @saveRegion="handleSaveRegion"
            v-if="data.receiverType.value === 'map'"
          />
          <!-- End:: Clients Type Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MapRegionSelector from "@/components/MapRegionSelector.vue";

export default {
  name: "CreateNotification",
  components: { MapRegionSelector },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allClientsData: "ApiGetsModule/allClientsData",
      allDriversData: "ApiGetsModule/allDriversData",
    }),
    // End:: Vuex Getters

    receiverTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.clients"),
          value: "client",
        },
        {
          id: 2,
          name: this.$t("MESSAGES.Festival providers"),
          value: "festival_provider",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.all"),
          value: "all",
        },
        {
          id: 4,
          name: this.$t("MESSAGES.Map"),
          value: "map",
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        receiverType: {
          id: null,
          name: null,
          value: null,
        },
        coordinates: [],
        clients: [],
        providers: [],
        client: [],
        provider: [],
        festivalProvider: [],
        titleAr: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
      },
      clientsPagination: {
        page: 0,
        limit: 20,
        search: "",
        hasMore: true,
        isLoading: false,
      },
      clientsSearchTimeout: null,
      festivalProviders: [],
      isFestivalProvidersLoading: false,

      // End:: Data Collection To Send
    };
  },
  watch: {
    "data.receiverType"() {
      if (this.data.receiverType.value !== "map") {
        this.data.coordinates = [];
      }
      if (this.data.receiverType.value !== "client") {
        this.data.client = [];
        this.resetClientsPagination();
        this.data.clients = [];
      } else if (this.data.clients.length === 0) {
        this.getClients();
      }

      if (this.data.receiverType.value !== "festival_provider") {
        this.data.festivalProvider = [];
        this.festivalProviders = [];
      } else if (this.festivalProviders.length === 0) {
        this.getFestivalProviders();
      }
    },
  },

  methods: {
    // End:: Vuex Actions
    handleSaveRegion(coordinates) {
      this.data.coordinates = coordinates;
    },
    handleClientsReachEnd() {
      this.getClients();
    },
    handleClientsSearch(searchQuery) {
      if (this.clientsSearchTimeout) {
        clearTimeout(this.clientsSearchTimeout);
      }

      this.clientsSearchTimeout = setTimeout(() => {
        const normalizedSearch = (searchQuery || "").trim();
        if (normalizedSearch === this.clientsPagination.search) {
          return;
        }

        this.clientsPagination.search = normalizedSearch;
        this.data.clients = [];
        this.resetClientsPagination();
        this.clientsPagination.search = normalizedSearch;
        this.getClients();
      }, 400);
    },
    resetClientsPagination() {
      this.clientsPagination.page = 0;
      this.clientsPagination.hasMore = true;
      this.clientsPagination.isLoading = false;
    },
    async getClients() {
      if (this.clientsPagination.isLoading || !this.clientsPagination.hasMore) {
        return;
      }

      this.clientsPagination.isLoading = true;

      try {
        const searchQuery = this.clientsPagination.search
          ? `&name=${encodeURIComponent(this.clientsPagination.search)}`
          : "";

        const res = await this.$axios({
          method: "GET",
          url: `clients?page=${this.clientsPagination.page}&limit=${this.clientsPagination.limit}&is_active=1${searchQuery}`,
        });

        const clientsList = res?.data?.data?.data || [];
        if (clientsList.length === 0) {
          this.clientsPagination.hasMore = false;
          return;
        }

        const existingIds = new Set(this.data.clients.map((item) => item.id));
        clientsList.forEach((value) => {
          const clientItem = {
            id: value.user?.id,
            name: value.user?.name,
          };

          if (clientItem.id && !existingIds.has(clientItem.id)) {
            this.data.clients.push(clientItem);
            existingIds.add(clientItem.id);
          }
        });

        this.clientsPagination.page += 1;
        if (clientsList.length < this.clientsPagination.limit) {
          this.clientsPagination.hasMore = false;
        }
      } catch (error) {
        console.log(error.response.data.message);
      } finally {
        this.clientsPagination.isLoading = false;
      }
    },

    mapFestivalProviderOptions(items) {
      return (items || []).map((item) => ({
        id: item.user?.id ?? item.user_id ?? item.id,
        name: item.name || item.name_ar || item.name_en,
      }));
    },

    async getFestivalProviders() {
      if (this.isFestivalProvidersLoading) {
        return;
      }

      this.isFestivalProvidersLoading = true;

      try {
        const res = await this.$axios({
          method: "GET",
          url: "festival-providers?page=0&limit=0&is_active=1",
        });

        this.festivalProviders = this.mapFestivalProviderOptions(
          res?.data?.data?.data || []
        );
      } catch (error) {
        console.log(error.response?.data?.message);
      } finally {
        this.isFestivalProvidersLoading = false;
      }
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      // if (!this.data.receiverType) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.receiverType"));
      //   return;
      // } else if (
      //   this.data.receiverType?.value === "clients" &&
      //   this.data.clients.length === 0
      // ) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.clientAtLeast"));
      //   return;
      // } else if (
      //   this.data.receiverType?.value === "providers" &&
      //   this.data.providers.length === 0
      // ) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.driverAtLeast"));
      //   return;
      // }

      // else
      if (!this.data.titleAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleAr"));
        return;
      } else if (!this.data.titleEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleEn"));
        return;
      } else if (!this.data.contentAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentAr"));
        return;
      } else if (!this.data.contentEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentEn"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.receiverType.value == "client") {
        this.data.client.forEach((element) => {
          REQUEST_DATA.append(`users[]`, element.id);
        });
      } else if (this.data.receiverType.value == "festival_provider") {
        this.data.festivalProvider.forEach((element) => {
          REQUEST_DATA.append(`users[]`, element.id);
        });
      } else if (this.data.receiverType.value == "map") {
        let coors = this.data.coordinates;
        coors.forEach((element, index) => {
          REQUEST_DATA.append(`area_points[${index}][lat]`, element.lat);
          REQUEST_DATA.append(`area_points[${index}][lng]`, element.lng);
        });
      }

      REQUEST_DATA.append("to_type", this.data.receiverType?.value ?? null);
      REQUEST_DATA.append("title[ar]", this.data.titleAr);
      REQUEST_DATA.append("title[en]", this.data.titleEn);
      REQUEST_DATA.append("body[ar]", this.data.contentAr);
      REQUEST_DATA.append("body[en]", this.data.contentEn);

      try {
        await this.$axios({
          method: "POST",
          url: `notification/store`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.sentSuccessfully"));
        this.$router.push({ path: "/all-notifications/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    // Clients are loaded lazily when receiver type is "client"
    // End:: Fire Methods
  },
  beforeDestroy() {
    if (this.clientsSearchTimeout) {
      clearTimeout(this.clientsSearchTimeout);
    }
  },
};
</script>
